import React from 'react';
import Hero from './Hero';
import About from './About';
import Research from './Research';
import Publications from './Publications';
import Philosophy from './Philosophy';
import Contact from './Contact';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <About />
      <Research />
      <Publications />
      <Philosophy />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;